import React, { Component, Fragment } from 'react';
import Input from '../FormInput/index';
import Dropdown from 'Components/Dropdown';
import { SHOW_TAT, TAT_UNITS_LAT } from 'Constants/commonConstants';
import { COUNTER_REJECT, COUNTER_ACCEPT } from 'Constants/commonConstants';

export default class AcceptanceOfCeilingPrice extends Component {
   constructor(props) {
      super(props); 
      const { biddingDetails } = this.props;
      this.state = {
        tatValue: biddingDetails.tatValue || 0,
        price: biddingDetails.qbr || '',
        tatUnit: {
           unit: biddingDetails.tatUnit || 0,
           name: biddingDetails.tatUnitName || ''
        },
        transporterVol:""
      }
   }
   

   submit = (e) => {

     if (e && e.preventDefault && e.stopPropagation) {
        e.stopPropagation();
        e.preventDefault();
     }
     const payloadData = {
        transporterVol: this.state.transporterVol,
        tat: {
           unit: this.state.tatUnit.unit,
           value: Number(this.state.tatValue),
           name: this.state.tatUnit.name
        }
     };
     payloadData['price'] = Number(this.state.price);
     payloadData['type'] = 0;
     payloadData['trip_id'] =this.props.tripId;
     payloadData['rfq_id'] =this.props.rfqId;
     this.props.submit(payloadData);
   }

   render() {
      return (
        <div className="flex flex-between flex-middle">
                  <span className="challenge-color curP pr-5 curP" onClick={(e) => this.submit(e)}>Accept Ceiling Price</span>
                  <span className="pr-5 curP"> / </span>
                  <span className="pr-5 error-color curP">Reject Ceiling Price</span><br />
               </div>
      )
   }
}
